import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom'
// import moment from 'moment'
import moment from "../utils/moment/moment"
import Popup from '../components/Popup'
import TouchFeedback from '../components/TouchFeedback'
import classnames from 'classnames'

import DateTimePicker from "../components/DateTimePicker"
import styles from "./App.less"


function App(props) {
    let { showDatePanel, datePanelType, mateFormat, defaultDate, upState, model, I18N, dateRange } = props

    const [show, setShow] = useState(false)

    const [currType, setCurrType] = useState("pre") //pre next

    const [formatMap, setFormatMap] = useState({ "year": "YYYY", "custom": mateFormat })

    const [formatType, setFormatType] = useState(defaultDate.length === 2 ? "custom" : "year")

    const _initval = moment().format(formatMap[formatType])
    const [preVal, setPreVal] = useState(_initval)
    const [nextVal, setNextVal] = useState(_initval)
    const [yeraVal, setYeraVal] = useState(_initval)
    const [dateVal, setDateVal] = useState(null)
    const [minDate, setMinDate] = useState(null)
    const [maxDate, setMaxDate] = useState(null)
    // const [curSelectVal, setCurSelectVal] = useState(null)
    const curSelectVal = useRef(null)

    useEffect(() => {
        if (showDatePanel) {
            // 打开面板
            setShow(showDatePanel)

            // 选择日期格式
            let _formatType = "year"

            if (datePanelType === "2" && defaultDate.length === 2) {
                _formatType = "custom"
            }

            // 如果限制了时间范围，需要判断返回的默认值是否超出了区间范围
            // 如果后端没有限制时间范围，则前端限定范围在1900-2999
            const _minDate = dateRange.length > 0 && dateRange[0] ? dateRange[0] : "1900-01"
            const _maxDate = dateRange.length > 0 && dateRange[1] ? dateRange[1] : "2999-12"

            setMinDate(_minDate)
            setMaxDate(_maxDate)

            if (_formatType === "year") {
                const defaultVal = handleRangeLimit(defaultDate[0], _minDate, _maxDate, "YYYY")
                setYeraVal(defaultVal)
                setPreVal(defaultVal) // 初始化的值取得是preVal，所以设置下
                curSelectVal.current = defaultVal
            } 
            if (_formatType === "custom") {
                const preDefaultVal = handleRangeLimit(defaultDate[0], _minDate, _maxDate, mateFormat)
                const nextDefaultVal = handleRangeLimit(defaultDate[1], _minDate, _maxDate, mateFormat)
                setPreVal(preDefaultVal)
                setNextVal(nextDefaultVal)
                curSelectVal.current = preDefaultVal
            }
            
            setDateVal(null)

            setFormatMap({
                "year": "YYYY",
                "custom": mateFormat
            })

            setCurrType("pre")

            setFormatType(_formatType)

        }
    }, [props.showDatePanel])

    const params = {
        initDate: moment(preVal),
        value: dateVal,
        minDate: moment(minDate),
        maxDate: moment(maxDate),
        format: formatMap[formatType],
        onDateChange: e => {
            const strDate = moment(e).format(formatMap[formatType])
            curSelectVal.current = strDate

            setDateVal(null)

            if (formatType === "year") {
                setYeraVal(strDate)
            }

            if (formatType === "custom") {
                if (currType === "pre") {
                    setPreVal(strDate)

                    if (moment(strDate) > moment(nextVal)) {
                        setNextVal(strDate)
                    }
                }
                if (currType === "next") {
                    setNextVal(strDate)

                    if (moment(strDate) < moment(preVal)) {
                        setPreVal(strDate)
                    }
                }
            }
        }
    }

    // 处理日期范围的限制
    function handleRangeLimit(date, minDate, maxDate, format) {
        let dateMoment = moment(date);
        let minDateMoment = minDate ? moment(minDate) : null;
        let maxDateMoment = maxDate ? moment(maxDate) : null;
    
        if (minDateMoment && dateMoment.isBefore(minDateMoment)) {
            dateMoment = minDateMoment.clone();
        }
        if (maxDateMoment && dateMoment.isAfter(maxDateMoment)) {
            dateMoment = maxDateMoment.clone();
        }
    
        return dateMoment ? dateMoment.format(format) : null;
    }

    function getMonthRange(start, end, yearStr) {
        const startDate = new Date(`${start}-01`);
        const endDate = new Date(`${end}-01`);

        // 将传入的年份转为number类型
        const year = parseInt(yearStr, 10);

        // 判断年份是否在范围内
        if (year < startDate.getFullYear() || year > endDate.getFullYear()) {
            return null;
        }

        const startMonth = startDate.getFullYear() === year ? startDate.getMonth() + 1 : 1;
        const endMonth = endDate.getFullYear() === year ? endDate.getMonth() + 1 : 12;

        const s_formatDate = `${year}-${startMonth < 10 ? '0' + startMonth : startMonth}`;
        const e_formatDate = `${year}-${endMonth < 10 ? '0' + endMonth : endMonth}`;

        return [s_formatDate, e_formatDate];
      }


    const toggleType = type => {
        const _format = formatMap[type]

        // 假设查询范围，23.04-25.01，那么：
        // 选中年份23年，切换自定义，默认选择23.04-23.12
        // 选中年份24年，切换自定义，默认选择24.01-24.12
        // 选中年份25年，切换自定义，默认选择25.01-25.01
        const [preM, nextM] = getMonthRange(minDate, maxDate, curSelectVal.current)
        const _preVal = moment(preM).format(_format)
        const _nextVal = moment(nextM).format(_format)

        setFormatType(type)
        setCurrType("pre")

        setPreVal(_preVal)
        setNextVal(_nextVal)
        setDateVal(moment(_preVal))
    }

    const toggleInp = type => {
        setCurrType(type)

        if (type === "pre") {
            setDateVal(moment(preVal))
        }
        if (type === "next") {
            setDateVal(moment(nextVal))
        }
    }

    const confirmDate = () => {
        const res = []
        let dateType = 1
        if (formatType === "year") {
            res.push(yeraVal)
            dateType = 1
        }
        if (formatType === "custom") {
            res.push(preVal, nextVal)
            dateType = 2
        }


        model.invoke("handleDate", {
            dateVal: res,
            dateType
        })

        console.log("选择的日期", {
            dateVal: res,
            dateType
        });
    }

    return (
        createPortal(
            <Popup
                key='popup_picker_date'
                show={show}
                title={I18N("title")}
                header={CustomHeader}
                className={styles['date-popup-picker']}
                onCancel={() => {
                    setShow(false)
                    upState("showDatePanel", false)
                }}
                onConfirm={() => {
                    setShow(false)
                    upState("showDatePanel", false)
                    confirmDate()
                }}
                footer={({ onConfirm, mustInput }) => CustomFooter({ onConfirm, mustInput, I18N })}
            >
                <div className={styles["i-popup-main"]}>
                    {
                        datePanelType === "2" && (
                            <div className={styles["navbar-box"]}>
                                <div className={styles["navbar"]}>
                                    <span className={classnames(styles["nav-item"], { [styles["active"]]: formatType === "year" })} onClick={() => { toggleType("year") }}>{I18N("slectY")}</span>
                                    <span className={classnames(styles["nav-item"], { [styles["active"]]: formatType === "custom" })} onClick={() => { toggleType("custom") }}>{I18N("slectC")}</span>
                                </div>
                            </div>
                        )
                    }
                    {
                        formatType === "custom" && datePanelType === "2" && (
                            <div className={styles["inp-box"]}>
                                <input type="text" value={preVal} readOnly
                                    onClick={() => {
                                        toggleInp("pre")
                                    }}
                                    style={{
                                        borderColor: currType === "pre" ? "#276FF5" : "#f2f2f2",
                                        width: "170px"
                                    }}
                                />
                                <span>-</span>
                                <input type="text" value={nextVal} readOnly
                                    onClick={() => {
                                        toggleInp("next")
                                    }}
                                    style={{
                                        borderColor: currType === "next" ? "#276FF5" : "#f2f2f2",
                                        width: "170px"
                                    }}
                                />
                            </div>
                        )
                    }
                    <div className={styles["picker-box"]}>
                        <DateTimePicker I18N={I18N} {...params} />
                    </div>
                </div>
            </Popup>
            , document.body)
    );
}

const CustomHeader = ({ onCancel, title }) => {
    return (
        <div className={classnames(styles['popup-header'], styles['border-buttom-1px'])}>
            <div className={styles['popup-header-title']}>{title}</div>
            <TouchFeedback activeClassName={styles['popup-header-btn-active']}>
                <div className={`kdfont kdfont-guanbi6 ${styles['icon-cancel']}`} onClick={onCancel} />
            </TouchFeedback>
        </div>
    )
}

const CustomFooter = ({ onConfirm, mustInput, I18N }) => {

    const locale = { confirm: I18N("select") }
    return (
        <div className={classnames(styles['popup-footer'], styles['border-buttom-1px'])}>
            {
                <TouchFeedback activeClassName={styles['popup-footer-btn-active']}>
                    <div className={styles[`popup-footer-confirm`]} onClick={onConfirm}>{locale.confirm}</div>
                </TouchFeedback>
            }
        </div>
    )
}

export default App;